import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import CelltrionCare from "../popup/celltrionCare";
import { Link } from "react-router-dom";
import bgLayer from "../../assets/img/bg-layer.png";
import cares from "../../assets/img/avtozma-card.svg";


export const AvtozmaEntry = () => {
  const [modalShow, setModalShow] = useState(false);
      const { category } = useParams();
      const productName = category;

  return (
    <>
      <section className={`${productName}-product-entry`}>
        <Container fluid>
          <div className="steqeyma-text">
            <Row className="enrollContent">
              <Col xs={12} md={8}>
                <h4>LOOKING FOR</h4>
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <h1 style={{ position: "relative", display: "inline-block" }}>
                    CO-PAY SUPPORT FOR AVTOZMA
                    <sup className="reg">
                      &reg;
                    </sup>{" "}
                    ?
                  </h1>
                </div>
                <Link to="/inquiry-form/avtozma" className="theme-btn">
                  Enroll Today
                </Link>
                <div className="entry-content-desktop">
                  <h5>
                    Commercially insured patients may be able to receive
                    assistance through the<br></br>
                    Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
                    Assistance Program*
                  </h5>
                  <ul>
                    <li>
                      If eligible, patients may pay as little as $0 for AVTOZMA
                    </li>
                    <li style={{ lineHeight: 1.5 }}>
                      Celltrion CARES provides assistance to help with patient
                      out-of-pocket costs for AVTOZMA
                    </li>
                  </ul>
                  <h5>
                    Eligibility criteria for the Celltrion CARES Co-pay
                    Assistance Program:
                  </h5>
                  <ul>
                    <li>Must have commercial or private insurance</li>
                    <li style={{ lineHeight: 1.5 }}>
                      {" "}
                      Must not have Medicare, Medicaid, or other government
                      insurance
                    </li>
                    <li>
                      Must meet certain guidelines set forth in the{" "}
                      <a
                        href="#"
                        onClick={() => setModalShow(true)}
                        style={{
                          color: "#000000",
                          textDecoration: "underline",
                        }}
                      >
                        Terms and Conditions
                      </a>{" "}
                      for the Celltrion CARES
                      <br></br>Co-pay Assistance Program
                    </li>
                  </ul>
                  <p style={{ color: "#000" }} className="disclaimer">
                    *Must be for an approved indication.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={4} className="entry-image-desktop" style={{marginTop: "40px"}}>
                <img
                  src={cares}
                  className='card-image'
                  alt=""
                />
              </Col>
            </Row>
          </div>
        </Container>
        <div className="steqeyma-text">
          <Col xs={12} md={4} className="entry-image-mobile mb-2">
            <img src={cares} style={{ width: "100%", height: "auto", maxWidth: "461px" }} alt="" />
          </Col>
          <div className="entry-content-mobile">
            <h5>
              Commercially insured patients may be able to receive assistance
              through the Celltrion CARES<sup className="reg">&reg;</sup> Co-pay
              Assistance Program*
            </h5>
            <ul>
              <li>
                If eligible, patients may pay as little as $0 for AVTOZMA
              </li>
              <li style={{ lineHeight: 1.5 }}>
                Celltrion CARES provides
                assistance to help with patient out-of-pocket costs for AVTOZMA
              </li>
            </ul>
            <h5>
              Eligibility criteria for the Celltrion CARES Co-pay Assistance Program:
            </h5>
            <ul>
              <li>Must have commercial or private insurance</li>
              <li style={{ lineHeight: 1.5 }}>
                {" "}
                Must not have Medicare, Medicaid, or other government insurance
              </li>
              <li>
                Must meet certain guidelines set forth in the{" "}
                <a
                  href="#"
                  onClick={() => setModalShow(true)}
                  style={{ color: "#006838", textDecoration: "underline" }}
                >
                  Terms and Conditions
                </a>{" "}
                for the Celltrion CARES Co-pay Assistance Program
              </li>
            </ul>
            <p style={{ color: "#000" }} className="disclaimer">
              *Must be for an approved indication.
            </p>
          </div>
        </div>
        <img src={bgLayer} className="bgLayer" alt="" />
      </section>         
      <CelltrionCare
        show={modalShow}
        onHide={() => setModalShow(false)}
        isVegzelma={false}
        isZymfentra={false}
        isYuflyma={false}
        isAdalimumab={false}
        isSteqeyma={true}
      />
    </>
  );
};
